import { useState, useEffect } from 'react';
import { checkProductReady } from '../function/CheckProductReady';
import '../css/ProductToDisplay.css';
import { useNavigation } from '../function/navigation';

function ProductToDisplay({ inputs, productState }) {
  const { nav, dispatch } = useNavigation();
  const [expand, setExpand] = useState(false);

  const nbrActiveProduct = inputs.product_tbh?.filter((product) =>
    checkProductReady(product)
  ).length;

  useEffect(() => {
    if (nbrActiveProduct < 1) {
      dispatch({ type: 'focusedProduct', payload: 0 });
    }
  }, [nbrActiveProduct, dispatch]);

  if (nbrActiveProduct < 1) {
    return null;
  }

  return (
    <div className="show-all-options">
      <div
        className="arrow-container-product"
        onClick={() => setExpand(!expand)}
      >
        <div className={`arrow ${expand ? 'up' : ''}`}></div>
      </div>
      {expand ? (
        <>
          <p>Select product </p>
          <label
            key={0}
            className={`show-all-option ${nav.focusedProduct === 0 ? 'active' : ''}`}
            onClick={() => dispatch({ type: 'focusedProduct', payload: 0 })}
          >
            No product
          </label>
          {inputs.product_tbh
            ?.filter((product) => checkProductReady(product))
            .map((product, index) => (
              <label
                key={index + 1}
                className={[
                  'show-all-option',
                  productState[index]?.size_checked ? 'checked' : 'not-checked',
                  nav.focusedProduct === index + 1 ? 'active' : '',
                ].join(' ')}
                onClick={() =>
                  dispatch({ type: 'focusedProduct', payload: index + 1 })
                }
              >
                {product['name']}
              </label>
            ))}
        </>
      ) : (
        <label
          key={nav.focusedProduct}
          className={[
            'show-all-option',
            !nav.focusedProduct
              ? ''
              : productState?.[nav.focusedProduct - 1]?.size_checked
                ? 'checked'
                : 'not-checked',
            'active',
          ].join(' ')}
          onClick={() => setExpand(true)}
        >
          {!nav.focusedProduct
            ? 'No product'
            : (inputs.product_tbh?.[nav.focusedProduct - 1]?.name ?? '')}
        </label>
      )}
    </div>
  );
}

export default ProductToDisplay;
